/**
 * Hub for app-wide communication about alerts.
 *
 * Properties:
 * - unreadAlerts: the current number of unread alerts
 */
import Backbone from 'backbone'

import _ from 'lodash'
import $ from 'jquery'

function Alerts() { }

_.extend(Alerts.prototype, Backbone.Events, {

	/**
	 *
	 * @param {Object} context The context to be passed to Backbone.on(), typically the
	 * Backbone view object.
	 * @param {Function} callback will be called with the new alerts data when
	 * it is received.  Allows the caller to render new alerts.
	 * @param {Number} [maxResults=200] the number of alerts to fetch
	 */
	listenForPushNotification: function(context, callback, maxResults) {
		// see setup-push-notificatons.js#subscribeNotifications
		const socketListener = ({numUnread, action}, opts) => {
			if (_.get(opts, 'push')) { // websocket push event - reload the alerts

				// No need to reload anything after a move/delete, the UI is updated before the XHR
				// And don't worry about other sessions/windows for the same user
				// https://github.com/SpiderStrategies/Scoreboard/issues/25068#issuecomment-504055553
				if (action !== 'create') {
					Backbone.trigger('change:unread', {numUnread})
				} else {
					// The remaining actions require re-rendering the view
					// (read/unread)
					$.get(`api/alerts?maxResults=${_.defaultTo(maxResults, 200)}`, newData => {
						Backbone.trigger('change:unread', {numUnread: newData.numUnread})
						callback(newData)
					})
				}
			}
		}
		// must send the context so we can remove it later. If we don't
		// XHR requests will be made for alerts even after the view is removed.
		Backbone.on('change:unread', socketListener, context)
	},

	stopListeningForPushNotification: function(context) {
		Backbone.off('change:unread', null, context)
	}

})

var alerts = new Alerts()

Backbone.on('load', function(data) {
	if (data.unreadAlerts) {
		alerts.unreadAlerts = data.unreadAlerts
	}
})

Backbone.on('change:unread', ({numUnread}) => {
	alerts.unreadAlerts = numUnread
})


export default alerts

alerts.__filename__ = 'components/alerts.js'
